import type {
  SelectOption,
  TaskDefinitionRequest,
} from 'src/api/ProactApiClient';
import {TaskDefinitionStateEnum} from 'src/api/ProactApiClient';
import {DueDatePreviewForm} from 'src/app/forms/DueDatePreviewForm';
import {taskFieldDefinitions} from 'src/app/tasks/taskHelpers';
import type {UseTaskFeatureFormMeta} from 'src/app/tasks/createTaskFeatureEditor';
import {
  createTaskFeatureEditor,
  useComplianceFormMeta,
} from 'src/app/tasks/createTaskFeatureEditor';
import {mapComplianceStandardIds} from 'src/app/tasks/taskFeatureTypes';
import type {IFormDataV2, IFormFieldV2} from 'src/types/FormV2';

export const getApprovalFormMeta = (
  taskState: TaskDefinitionStateEnum,
  standards: SelectOption[]
): IFormFieldV2[] => [
  taskFieldDefinitions.projectId,
  taskFieldDefinitions.willAssignTo,
  taskFieldDefinitions.subject,
  taskFieldDefinitions.dueInDays,
  taskState === TaskDefinitionStateEnum.Draft
    ? taskFieldDefinitions.previewDueDate
    : taskFieldDefinitions.dueDate,
  taskFieldDefinitions.content,
  taskFieldDefinitions.complianceStandards(standards),
];

export const mapApprovalRequest = (
  values: IFormDataV2
): TaskDefinitionRequest => ({
  projectId: values.projectId,
  targetSourceEntityRequest: values.sourceEntities,
  subject: values.subject ?? '',
  dueInDays: values.dueInDays,
  content: values.content ?? '',
  targetComplianceStandardIds: mapComplianceStandardIds(values),
});

export const useApprovalFormMeta: UseTaskFeatureFormMeta = (
  taskState,
  transformMeta
) => useComplianceFormMeta(getApprovalFormMeta, taskState, transformMeta);

export const ApprovalEditor = createTaskFeatureEditor(
  useApprovalFormMeta,
  mapApprovalRequest,
  DueDatePreviewForm
);
